import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import SmoothScroll from "@/components/SmoothScroll";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Book from "@/pages/Book";
import ReflectionNightsPage from "@/pages/ReflectionNightsPage";
import OutpouredHousePage from "@/pages/OutpouredHousePage";
import OutpouredCommunityPage from "@/pages/OutpouredCommunityPage";
import CohortsPage from "@/pages/CohortsPage";
import ApplyPage from "@/pages/ApplyPage";
import CreateWithUs from "@/pages/CreateWithUs";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminPage from "@/pages/AdminPage";
import { PortalRoot, ProtectedRoute } from "@/context/PortalAuth";
import PortalShell from "@/pages/portal/PortalShell";
import PortalLogin from "@/pages/portal/PortalLogin";
import ResetPassword from "@/pages/portal/ResetPassword";
import Dashboard from "@/pages/portal/Dashboard";
import Today from "@/pages/portal/Today";
import Journey from "@/pages/portal/Journey";
import Challenges from "@/pages/portal/Challenges";
import Community from "@/pages/portal/Community";
import Duo from "@/pages/portal/Duo";
import Pulse from "@/pages/portal/Pulse";
import Certificate from "@/pages/portal/Certificate";
import ReflectionJourney from "@/pages/portal/ReflectionJourney";
import MyVessel from "@/pages/portal/MyVessel";
import Library from "@/pages/portal/Library";
import JourneyFlow from "@/pages/portal/JourneyFlow";
import Profile from "@/pages/portal/Profile";
import Messages from "@/pages/portal/Messages";
import FormationDashboard from "@/pages/portal/FormationDashboard";
import Calls from "@/pages/portal/Calls";
import ManagePortal from "@/pages/portal/ManagePortal";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SmoothScroll />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/book" element={<Book />} />
            <Route path="/reflection-nights" element={<ReflectionNightsPage />} />
            <Route path="/outpoured-house" element={<OutpouredHousePage />} />
            <Route path="/community" element={<OutpouredCommunityPage />} />
            <Route path="/cohorts" element={<CohortsPage />} />
            <Route path="/apply" element={<ApplyPage />} />
            <Route path="/create-with-us" element={<CreateWithUs />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Route>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/portal" element={<PortalRoot />}>
            <Route path="login" element={<PortalLogin />} />
            <Route path="reset" element={<ResetPassword />} />
            <Route path="flow" element={<ProtectedRoute><JourneyFlow /></ProtectedRoute>} />
            <Route element={<PortalShell />}>
              <Route index element={<Dashboard />} />
              <Route path="today" element={<Today />} />
              <Route path="journey" element={<Journey />} />
              <Route path="reflection" element={<ReflectionJourney />} />
              <Route path="vessel" element={<MyVessel />} />
              <Route path="library" element={<Library />} />
              <Route path="challenges" element={<Challenges />} />
              <Route path="community" element={<Community />} />
              <Route path="duo" element={<Duo />} />
              <Route path="formation" element={<FormationDashboard />} />
              <Route path="garden" element={<FormationDashboard />} />
              <Route path="pulse" element={<Pulse />} />
              <Route path="certificate" element={<Certificate />} />
              <Route path="calls" element={<Calls />} />
              <Route path="gatherings" element={<Calls />} />
              <Route path="me" element={<Profile />} />
              <Route path="messages" element={<Messages />} />
              <Route path="profile/:userId" element={<Profile />} />
              <Route path="manage" element={<ProtectedRoute adminOnly><ManagePortal /></ProtectedRoute>} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
